<script>
export default {
  name: "htmlStyle",
  render(createElement) {
    return createElement("style", this.$slots.default);
  }
};
</script>
